import api, { unwrap, downloadFile } from './client';

export const listTenants = () => unwrap(api.get('/tenants/'));
export const createTenant = (payload) => unwrap(api.post('/tenants/', payload));
export const updateTenant = (id, payload) => unwrap(api.patch(`/tenants/${id}`, payload));
export const deleteTenant = (id) => unwrap(api.delete(`/tenants/${id}`));

// Sauvegarde complète (JSON, toutes les tables du tenant) + restauration par module.
export const dumpTenant = (id) => unwrap(api.get(`/tenants/${id}/dump`));

/* Sauvegarde de TOUS les clients : une archive ZIP, un JSON par client, plus un
   manifeste. Réservée à l'exploitant (garde posée sur l'endpoint). La sortie est
   journalisée côté serveur. */
export const dumpAllTenants = () =>
  downloadFile('/tenants/dump-all',
    `palestre_sauvegarde_complete_${new Date().toISOString().slice(0, 10)}.zip`);
/* `confirmed` : l'utilisateur a vu le constat de ce que la restauration détruit.
   Sans lui, le serveur refuse (409) et renvoie ce constat — rien n'est modifié.
   Ce 409-là n'est pas une erreur : on le sort du chemin `unwrap` (qui lèverait
   un toast global) et on renvoie le constat à l'écran de confirmation. */
export const restoreTenant = async (id, modules, dump, confirmed = false) => {
  try {
    const r = await api.post(`/tenants/${id}/restore`, { modules, dump, confirmed });
    return r.data;
  } catch (e) {
    const detail = e.response?.data?.detail;
    if (e.response?.status === 409 && detail?.code === 'restore_needs_confirmation') {
      return { data: null, error: null, preflight: detail.preflight };
    }
    const msg = typeof detail === 'string' ? detail : (e.response?.data?.error || e.message);
    return { data: null, error: msg };
  }
};

// Onglets du cockpit (self-service : éditable par un membre du tenant).
export const updateCockpitTabs = (id, cockpit_tabs) =>
  unwrap(api.patch(`/tenants/${id}/cockpit-tabs`, { cockpit_tabs }));

// Taux de TVA par année (source unique year-aware).
export const listVatRates = (id) => unwrap(api.get(`/tenants/${id}/vat-rates`));
export const upsertVatRate = (id, year, payload) =>
  unwrap(api.put(`/tenants/${id}/vat-rates/${year}`, payload));
export const deleteVatRate = (id, year) =>
  unwrap(api.delete(`/tenants/${id}/vat-rates/${year}`));

/* Journal de gouvernance (Cockpit › Journal & décisions) — table dédiée depuis
   le 2026-08-11. Il vivait dans `tenant.notes`, donc livré avec la fiche client
   que tout utilisateur rattaché peut lire. */
export const getGovernanceJournal = (tenantId) =>
  unwrap(api.get(`/governance/journal/${tenantId}`));
export const putGovernanceJournal = (tenantId, data) =>
  unwrap(api.put(`/governance/journal/${tenantId}`, { data }));
